import { gql } from "@apollo/client";

export const CREATE_TENANTS = gql`
mutation createTenant(
    $arcimedes_row_id: ID,
    $name: String!,
    $deleted: Int 
) {
    createOrUpdateTenent(input: {
        arcimedes_row_id: $arcimedes_row_id,
        name: $name,
        deleted: $deleted
    }) {
        tenent {
            arcimedes_row_id
            name
            deleted
        }
    }
}
`

